export function formatEventDate(value: string | null | undefined) {
  if (!value) return "Date TBD";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "Date TBD";

  return date.toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
}

export function formatEventDateTime(value: string | null | undefined) {
  if (!value) return "Date TBD";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "Date TBD";

  return date.toLocaleString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

// Value for a <input type="datetime-local">, which needs local time, no zone.
export function toDatetimeLocal(value: string | null | undefined) {
  if (!value) return "";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}
